import SideNav from "../SideNav/SideNav";
import Fancybox from "../Fancybox/Fancybox";
import '@fancyapps/ui/dist/fancybox/fancybox.css';

import { Image } from "react-bootstrap";

import screenshot1 from '../../assets/img/screenshots/management_system/1.jpg';
import screenshot2 from '../../assets/img/screenshots/management_system/2.jpg';
import screenshot3 from '../../assets/img/screenshots/management_system/3.jpg';
import screenshot4 from '../../assets/img/screenshots/management_system/4.jpg';
import screenshot5 from '../../assets/img/screenshots/management_system/5.jpg';

function Management() {

    return (
<div id="wrap-body">
            <div class="heading-group page-name color-w">
                <h1>Management System</h1>
                <div class="intro">
                    <p>The Management System includes an integrated PPD Budget Manager that reports planned PPD, allowable budget based on census, current expenses, actual PPD and monthly balance. This can be reviewed at any time to offer guidance on purchases. The Management System also includes resources necessary for dining operations: training videos, direct order entry link to food distributors, policies and procedures, foodservice specific in-services/quizzes and operational forms.</p>
                </div>
                <div class="star-group">
                    <i class="fa fa-star-o"></i>
                    <i class="fa fa-star-o star-1x"></i>
                    <i class="fa fa-star-o"></i>
                </div>
            </div>
            <div class="container" id="main-content">
                <div class="reservation">
                    <div class="title">Management System
                        <h3>Highlights</h3>
                    </div>
                    <div class="row">
                        <div class="col-md-8">
                        <ul class="custom_list">
                                <li>Automated Budget report system allows the user to enter budget for cost centers annually. Enter invoice amounts manually/integrated that total monthly costs. This data generates a Budget Report that shows budget, allowable expenses based on current census/additional meals, expenses to date, per day costs and monthly balance. This automated system is a great tool for tracking and maintaining desired budgets.</li>
                                <li>The Help Desk Tab includes training videos for each of the software systems allowing the user to get refresher training sessions in the privacy of their office. It also includes an Online User Manual, FAQs, and 24-7 Tech Support at no additional costs.</li>
                                <li>Complete Dining Policy &amp; Procedure Manual frequently updated to comply with national trends and/or changes in regulations.</li>
                                <li>Annual Dining Operations In-services (12) with quizzes that are updated every January.</li>
                                <li>Operational forms for kitchen management, resident assessments, and cost management.</li>
                            </ul>
                        </div>
                        <div class="col-md-4">
                        <Fancybox
                                options={{
                                    Carousel: {
                                        infinite: false,
                                    },
                                }}
                            >
                            <a href={screenshot1} data-fancybox="screenshots" data-caption="Budget Report" id="lnk_screenshots">See screenshot samples</a>
                            <div style={{display:'none'}}>
                                <a href={screenshot2} data-fancybox="screenshots" data-caption="Help Desk/Support">
                                    <Image src={screenshot2}></Image>
                                </a>
                                <a href={screenshot3} data-fancybox="screenshots" data-caption="Policies &amp; Procedures">
                                    <Image src={screenshot3}></Image>
                                </a>
                                <a href={screenshot4} data-fancybox="screenshots" data-caption="Forms">
                                    <Image src={screenshot4}></Image>
                                </a>
                                <a href={screenshot5} data-fancybox="screenshots" data-caption="In-Service">
                                    <Image src={screenshot5}></Image>
                                </a>
                            </div>
                        </Fancybox>
                        <SideNav/>
                        </div>
                    </div>
                </div>
            </div>
        </div>    );


}

export default Management;